/**
 * Maison Artisane - Custom Scripts
 * Menu animations and GSAP functionality
 */

(function() {
  'use strict';

  // Wait for DOM to be ready
  document.addEventListener('DOMContentLoaded', function() {
    
    // Initialize menu functionality
    initMenu();
    
    // Initialize GSAP animations if available
    if (typeof gsap !== 'undefined') {
      initGSAPAnimations();
    }
    
    // Initialize other interactions
    initInteractions();
  });

  /**
   * Menu functionality
   */
  function initMenu() {
    const menuTrigger = document.querySelector('.nav_trg');
    const nav = document.querySelector('.nav');
    const navClose = document.querySelector('.nav_close');
    const body = document.body;

    if (menuTrigger && nav) {
      // Open menu
      menuTrigger.addEventListener('click', function(e) {
        e.preventDefault();
        openMenu();
      });

      // Close menu
      if (navClose) {
        navClose.addEventListener('click', function(e) {
          e.preventDefault();
          closeMenu();
        });
      }

      // Close menu on escape key
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && nav.classList.contains('nav--open')) {
          closeMenu();
        }
      });

      // Close menu when clicking outside
      document.addEventListener('click', function(e) {
        if (nav.classList.contains('nav--open') && 
            !nav.contains(e.target) && 
            !menuTrigger.contains(e.target)) {
          closeMenu();
        }
      });
    }

    function openMenu() {
      if (nav) {
        nav.classList.add('nav--open');
        body.classList.add('menu-open');
        
        // Prevent body scroll
        body.style.overflow = 'hidden';
        
        // Add animation class if GSAP is available
        if (typeof gsap !== 'undefined') {
          gsap.fromTo(nav, 
            { opacity: 0, y: -20 },
            { opacity: 1, y: 0, duration: 0.3, ease: "power2.out" }
          );
        }
      }
    }

    function closeMenu() {
      if (nav) {
        nav.classList.remove('nav--open');
        body.classList.remove('menu-open');
        
        // Restore body scroll
        body.style.overflow = '';
        
        // Add close animation if GSAP is available
        if (typeof gsap !== 'undefined') {
          gsap.to(nav, {
            opacity: 0,
            y: -20,
            duration: 0.2,
            ease: "power2.in",
            onComplete: function() {
              nav.style.opacity = '';
              nav.style.transform = '';
            }
          });
        }
      }
    }
  }

  /**
   * GSAP Animations
   */
  function initGSAPAnimations() {
    // Register ScrollTrigger if available
    if (typeof ScrollTrigger !== 'undefined') {
      gsap.registerPlugin(ScrollTrigger);
    }

    // Parallax effects for images
    initParallaxEffects();
    
    // Fade in animations
    initFadeAnimations();
    
    // Hover effects
    initHoverEffects();
  }

  function initParallaxEffects() {
    if (typeof ScrollTrigger === 'undefined') return;

    // Section images parallax
    gsap.utils.toArray(".section-image_img").forEach(function(img) {
      gsap.to(img, {
        yPercent: -30,
        scrollTrigger: {
          trigger: img.closest(".section-image"),
          start: "top bottom",
          end: "bottom top",
          scrub: true
        }
      });
    });

    // Hero background parallax
    gsap.utils.toArray(".hero_bg").forEach(function(bg) {
      gsap.to(bg, {
        y: -150,
        scrollTrigger: {
          trigger: bg.closest(".hero"),
          start: "top top",
          end: "bottom top",
          scrub: true
        }
      });
    });

    // About hero image parallax
    gsap.utils.toArray(".about-hero_image").forEach(function(img) {
      gsap.to(img, {
        y: -150,
        scrollTrigger: {
          trigger: img.closest(".about-hero"),
          start: "top top",
          end: "bottom top",
          scrub: true
        }
      });
    });
  }

  function initFadeAnimations() {
    if (typeof ScrollTrigger === 'undefined') return;

    // Collection items fade in
    gsap.fromTo(".collection_item", 
      { 
        opacity: 0, 
        y: 50 
      },
      {
        opacity: 1,
        y: 0,
        duration: 0.8,
        stagger: 0.1,
        scrollTrigger: {
          trigger: ".collection",
          start: "top 80%",
          end: "bottom 20%",
          toggleActions: "play none none reverse"
        }
      }
    );

    // Text sections fade in
    gsap.fromTo(".text-content", 
      { 
        opacity: 0, 
        y: 30 
      },
      {
        opacity: 1,
        y: 0,
        duration: 0.6,
        scrollTrigger: {
          trigger: ".text-content",
          start: "top 85%",
          toggleActions: "play none none reverse"
        }
      }
    );
  }

  function initHoverEffects() {
    // Collection item hover effects
    gsap.utils.toArray(".collection_item").forEach(function(item) {
      const image = item.querySelector(".item_image");
      
      if (image) {
        item.addEventListener('mouseenter', function() {
          gsap.to(image, {
            scale: 1.1,
            duration: 0.3,
            ease: "power2.out"
          });
        });
        
        item.addEventListener('mouseleave', function() {
          gsap.to(image, {
            scale: 1,
            duration: 0.3,
            ease: "power2.out"
          });
        });
      }
    });


  }

  /**
   * Other interactions
   */
  function initInteractions() {
    // Smooth scroll for anchor links
    document.querySelectorAll('a[href^="#"]').forEach(function(link) {
      link.addEventListener('click', function(e) {
        const target = document.querySelector(this.getAttribute('href'));
        if (target) {
          e.preventDefault();
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    });

    // Form enhancements
    initFormEnhancements();
  }

  function initFormEnhancements() {
    // Newsletter form enhancements
    const newsletterForm = document.getElementById('footer-newsletter-form');
    if (newsletterForm) {
      newsletterForm.addEventListener('submit', function(e) {
        const submitButton = this.querySelector('input[type="submit"]');
        if (submitButton) {
          submitButton.value = 'Inscription...';
          submitButton.disabled = true;
          
          // Re-enable after 3 seconds as fallback
          setTimeout(function() {
            submitButton.value = 'REJOINDRE';
            submitButton.disabled = false;
          }, 3000);
        }
      });
    }

    // Coming soon form enhancements
    const comingSoonForm = document.getElementById('coming-soon-form');
    if (comingSoonForm) {
      comingSoonForm.addEventListener('submit', function(e) {
        const submitButton = this.querySelector('button[type="submit"]');
        if (submitButton) {
          const originalText = submitButton.textContent;
          submitButton.textContent = 'Inscription...';
          submitButton.disabled = true;
          
          // Re-enable after 3 seconds as fallback
          setTimeout(function() {
            submitButton.textContent = originalText;
            submitButton.disabled = false;
          }, 3000);
        }
      });
    }
  }

})();
